"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.includeScreen = includeScreen;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _eventNames = require("./constants/eventNames");

var _immutable = require("immutable");

var _fromJS;

var SCREENS = (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _eventNames.RECORD_INTERACTION, {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal',
  QUOTE: 'Quote',
  TICKET: 'Ticket'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.INDEX_INTERACTION, {
  CONTACT: 'Contact index',
  COMPANY: 'Company index',
  DEAL: 'Deal Index',
  TICKET: 'Ticket index',
  TASK: 'Tasks',
  VISIT: 'Visits'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.INTERNAL_CRM_TRACKING, {
  CONTACT: 'Contacts',
  COMPANY: 'Companies',
  DEAL: 'Deals',
  TASK: 'Tasks',
  VISIT: 'Visits'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.SETTINGS_INTERACTION, {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.CRM_ONBOARDING, {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal',
  QUOTE: 'Quote',
  TASK: 'Tasks',
  SETTINGS: 'Settings'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.CRM_API_ERROR, {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal',
  TASK: 'Tasks'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.CRM_DEBUG, {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal',
  TASK: 'Tasks'
}), (0, _defineProperty2.default)(_fromJS, _eventNames.BIZOPS_INTERACTION, {
  CONTACT: 'Contact',
  COMPANY: 'Company',
  DEAL: 'Deal'
}), _fromJS));
var defaultProps = {
  app: 'CRM'
};

var _isValidConfig = function _isValidConfig(event, objectType) {
  return SCREENS.hasIn([event, objectType]);
};

function includeScreen(_ref) {
  var event = _ref.event,
      objectType = _ref.objectType,
      eventProps = _ref.eventProps;

  if (!_isValidConfig(event, objectType)) {
    // eslint-disable-next-line no-console
    console.warn('Invalid event or objectType sent to MakeLogEventProps: ', event, objectType);
    return undefined;
  }

  var screen = SCREENS.getIn([event, objectType]);
  return {
    event: event,
    objectType: objectType,
    eventProps: (0, _extends2.default)({
      screen: screen
    }, defaultProps, eventProps)
  };
}